import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Alert, Card, Divider, Grid, Stack, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {
  getVendorByVendorID,
  postCreateVendor,
  putCreateVendor,
} from "../../Utils/vendor-customer-service";

const steps = ["Firm Account Setup", "Firm Shipping information"];

export default function CreateEditVendorStepper() {
  let [searchParams] = useSearchParams();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [vendorObj, setVendorObj] = React.useState({});
  const [showUpdateButton, setShowUpdateButton] = React.useState(false);
  const navigate = useNavigate();
  React.useEffect(() => {
    const vid = searchParams.get("vendorId");
    if (vid) {
      setShowUpdateButton(true);
      fetchVendorDetails(vid);
    }
  }, [searchParams]);
  const fetchVendorDetails = (vendorID) => {
    return getVendorByVendorID(vendorID).then((res) => {
      if (res?.data) {
        setVendorObj(res?.data);
      }
    });
  };
  const createVendorData = (event) => {
    event.preventDefault();
    console.log("vendorObj gaya", vendorObj);
    postCreateVendor(vendorObj)
      .then((response) => {
        console.log("response", response);
        if (response?.status === 200) {
          navigate("/vendors");
        }
      })
      .catch((err) => {});
  };
  const updateVendorData = (event) => {
    event.preventDefault();
    console.log("vendorObj gaya", vendorObj);
    putCreateVendor(vendorObj)
      .then((response) => {
        console.log("response", response);
        if (response?.status === 204) {
          navigate("/vendors");
        }
      })
      .catch((err) => {});
  };
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const isDisabled = () => {
    return (
      !vendorObj.name ||
      !vendorObj.nickName ||
      !vendorObj.phoneNumber ||
      !vendorObj.vendorAddress
    );
  };

  const step1FirmAccount = () => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="name"
              required
              fullWidth
              id="name"
              label="Full Name"
              autoFocus
              value={vendorObj.name}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  name: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              id="nickName"
              label="Nick Name"
              name="nickName"
              value={vendorObj.nickName}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  nickName: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="email"
              label="Primary Email Address"
              name="email"
              autoComplete="email"
              value={vendorObj.email}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  email: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              name="phoneNumber"
              label="Phone No."
              type="number"
              id="phoneNumber"
              value={vendorObj.phoneNumber}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  phoneNumber: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="mobileNumber"
              label="Mobile No."
              type="number"
              id="mobileNumber"
              value={vendorObj.mobileNumber}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  mobileNumber: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="communicateNumber"
              label="Whatsapp No."
              type="number"
              id="communicateNumber"
              value={vendorObj.communicateNumber}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  communicateNumber: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="city"
              label="City"
              name="city"
              value={vendorObj.city}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  city: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="vendorType"
              label="Vendor Type"
              name="vendorType"
              value={vendorObj.vendorType}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  vendorType: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              name="vendorAddress"
              label="Full Address"
              id="vendorAddress"
              multiline
              rows={5}
              helperText={"This address is not shipping address."}
              value={vendorObj.vendorAddress}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  vendorAddress: e.target.value,
                }))
              }
            />
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="notes"
              label="Notes"
              id="notes"
              multiline
              rows={3}
              helperText={"Notes on this vendor."}
              value={vendorObj.notes}
              onChange={(e) =>
                setVendorObj((prevData) => ({
                  ...prevData,
                  notes: e.target.value,
                }))
              }
            />
          </Grid>
        </Grid>
      </>
    );
  };
  const step2FirmAccount = () => {
    return (
      <>
        <Card variant="outlined">
          <Box sx={{ p: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography gutterBottom variant="h5" component="div">
                Shipping Addresses
              </Typography>
              <Typography gutterBottom variant="h6" component="div">
                3
              </Typography>
            </Stack>
            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
              You can add upto <strong> 3 </strong> shipping address per firm
              account. Your action will create dedicated shipping addresses for
              your app.
            </Alert>
            <Grid item sx={{ mt: 2, mb: 2 }} xs={12}>
              <Typography color="text.secondary" variant="button">
                Address 1
              </Typography>
              <TextField
                required
                fullWidth
                name="shippingAddress1"
                id="shippingAddress1"
                multiline
                rows={4}
                value={vendorObj.shippingAddress1}
                onChange={(e) =>
                  setVendorObj((prevData) => ({
                    ...prevData,
                    shippingAddress1: e.target.value,
                  }))
                }
              />
              <Divider textAlign="left">
                <Typography color="text.secondary" variant="button">
                  Address 1 ENDS
                </Typography>
              </Divider>
            </Grid>
            <Grid item sx={{ mt: 2, mb: 2 }} xs={12}>
              <Typography color="text.secondary" variant="button">
                Address 2
              </Typography>
              <TextField
                required
                fullWidth
                name="shippingAddress2"
                id="shippingAddress2"
                multiline
                rows={4}
                value={vendorObj.shippingAddress2}
                onChange={(e) =>
                  setVendorObj((prevData) => ({
                    ...prevData,
                    shippingAddress2: e.target.value,
                  }))
                }
              />
              <Divider textAlign="left">
                <Typography color="text.secondary" variant="button">
                  Address 2 ENDS
                </Typography>
              </Divider>
            </Grid>
            <Grid item sx={{ mt: 2, mb: 2 }} xs={12}>
              <Typography color="text.secondary" variant="button">
                Address 3
              </Typography>
              <TextField
                required
                fullWidth
                name="shippingAddress3"
                id="shippingAddress3"
                multiline
                rows={4}
                value={vendorObj.shippingAddress3}
                onChange={(e) =>
                  setVendorObj((prevData) => ({
                    ...prevData,
                    shippingAddress3: e.target.value,
                  }))
                }
              />
              <Divider textAlign="left">
                <Typography color="text.secondary" variant="button">
                  Address 3 ENDS
                </Typography>
              </Divider>
            </Grid>
          </Box>
          <Divider />
          <Divider />
          <Box sx={{ p: 2 }}>
            <Typography gutterBottom variant="body2">
              {!showUpdateButton && (
                <Button
                  onClick={createVendorData}
                  variant="contained"
                  color="success"
                  size="large"
                  startIcon={<CheckIcon />}
                >
                  Submit Firm Details
                </Button>
              )}
              {showUpdateButton && (
                <Button
                  onClick={updateVendorData}
                  variant="contained"
                  color="warning"
                  size="large"
                  startIcon={<CheckIcon />}
                >
                  Update Firm Details
                </Button>
              )}
            </Typography>
          </Box>
        </Card>
      </>
    );
  };

  // const step2FirmAccounts = () => {
  //   return (
  //     <>
  //       <Card variant="outlined">
  //         <Box sx={{ p: 2 }}>
  //           <Stack
  //             direction="row"
  //             justifyContent="space-between"
  //             alignItems="center"
  //           >
  //             <Typography gutterBottom variant="h5" component="div">
  //               Owner
  //             </Typography>
  //             <Typography gutterBottom variant="h6" component="div">
  //               0
  //             </Typography>
  //           </Stack>
  //           <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
  //             You can add upto <strong> 3 </strong> owner per firm account. Your
  //             action will create dedicated owner account for your app.
  //           </Alert>
  //           <Typography color="text.secondary" variant="body2"></Typography>
  //           []
  //         </Box>
  //         <Divider />
  //         <Box sx={{ p: 2 }}>
  //           <Typography gutterBottom variant="body2">
  //             <Button
  //               variant="contained"
  //               color="success"
  //               size="large"
  //               startIcon={<AddIcon />}
  //             >
  //               Owner
  //             </Button>
  //           </Typography>
  //         </Box>
  //       </Card>
  //       <Card sx={{ mt: 2 }} variant="outlined">
  //         <Box sx={{ p: 2 }}>
  //           <Stack
  //             direction="row"
  //             justifyContent="space-between"
  //             alignItems="center"
  //           >
  //             <Typography gutterBottom variant="h5" component="div">
  //               Employee
  //             </Typography>
  //             <Typography gutterBottom variant="h6" component="div">
  //               0
  //             </Typography>
  //           </Stack>
  //           <Alert icon={<CheckIcon fontSize="inherit" />} severity="info">
  //             You can add upto <strong> 7 </strong> owner per firm account. Your
  //             action will create dedicated owner account for your app.
  //           </Alert>
  //           <Typography color="text.secondary" variant="body2"></Typography>
  //         </Box>
  //         <Divider />
  //         <Box sx={{ p: 2 }}>
  //           <Typography gutterBottom variant="body2">
  //             <Button
  //               variant="contained"
  //               size="small"
  //               color="info"
  //               startIcon={<AddIcon />}
  //             >
  //               Employee
  //             </Button>
  //           </Typography>
  //         </Box>
  //       </Card>
  //     </>
  //   );
  // };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div>
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
            Step {activeStep + 1}
          </Typography>
          <React.Fragment>
            {activeStep + 1 === 1 && step1FirmAccount()}
          </React.Fragment>
          <React.Fragment>
            {activeStep + 1 === 2 && step2FirmAccount()}
          </React.Fragment>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            {
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
                variant="contained"
              >
                Back
              </Button>
            }
            <Box sx={{ flex: "1 1 auto" }} />
            {activeStep < 1 && (
              <Button
                variant="contained"
                disabled={isDisabled()}
                onClick={handleNext}
                sx={{ mr: 1 }}
              >
                Next
              </Button>
            )}
          </Box>
        </React.Fragment>
      </div>
    </Box>
  );
}
